/*!
 * @license
 * Copyright © 2005-2024 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { ImageUploadRepresentation } from '../model/imageUploadRepresentation';
import { UserRepresentation } from '../model/userRepresentation';
import { BaseApi } from './base.api';
import { throwIfNotDefined } from '../../../assert';
export class UserProfileApi extends BaseApi {
    changePassword(changePasswordRepresentation) {
        throwIfNotDefined(changePasswordRepresentation, 'changePasswordRepresentation');
        return this.post({
            path: '/api/enterprise/profile-password',
            bodyParam: changePasswordRepresentation
        });
    }
    getProfilePicture() {
        return this.get({
            path: '/api/enterprise/profile-picture',
            accepts: ['application/json', '*/*']
        });
    }
    getProfilePictureUrl() {
        return this.apiClient.basePath + '/app/rest/admin/profile-picture';
    }
    getProfile() {
        return this.get({
            path: '/api/enterprise/profile',
            returnType: UserRepresentation
        });
    }
    updateProfile(userRepresentation) {
        throwIfNotDefined(userRepresentation, 'userRepresentation');
        return this.post({
            path: '/api/enterprise/profile',
            bodyParam: userRepresentation,
            returnType: UserRepresentation
        });
    }
    uploadProfilePicture(file) {
        throwIfNotDefined(file, 'file');
        const formParams = {
            file
        };
        return this.post({
            path: '/api/enterprise/profile-picture',
            formParams,
            returnType: ImageUploadRepresentation
        });
    }
}
